export const UPDATE_TAGS_STATE = "UPDATE_TAGS_STATE"
export const TAG_CREATED = "TAG_CREATED"
export const TAG_UPDATED = "TAG_UPDATED"
export const TAG_DELETED = "TAG_DELETED"
